<script setup lang="ts">
const categories = ref([
  {
    description:
      "We have chosen WebReinvent Technologies after a long research. We have cross checked capabilities and reviews of many vendors and finally awarded our projects to WebReinvent. I can proudly say that my decision was correct. They have given value to my business and were sincere and caring towards the project throughout it’s lifecycle.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/zack.webp",
  },
  {
    description:
      "From the first day of our contact, we found every member of this team is very friendly and helpful. I never felt that I am being down because of my less technical knowledge. They not only make web applications for you but they train you very well to use them as well. By coming in contact of these guys, I started taking more educate decisions.",
    authName: "Tiffani A. Gilbert",
    authRole: "CEO",
    authImg: "/images/taffain.webp",
  },
  {
    description:
      "Many, many thanks for your fast and efficient delivery of work. We have been really, really impressed with the level of customer service Web reinvent has provided to date. Please pass our thanks and congratulations to your team involved in IFLIIP project. Will definitely recommend your company’s capabilities and genuine delivery of work to others.",
    authName: "Ankur Shah",
    authRole: "CEO",
    authImg: "/images/ankur.webp",
  },
  {
    description:
      "They appeared in my business as an ultimate solution. We were in a total loss as our previous designers have not completed my projects and stuck with it at a crucial stage. They came with brilliant ideas in a tight deadline, did all the needful and made everything working at more than satisfactory level.",
    authName: "Pranjal",
    authRole: "CEO",
    authImg: "/images/pranjal.webp",
  },
  {
    description:
      "WebReinvent started with Voltaic's designs for a new site and transformed them into a fully-responsive site on Magento. The WebReinvent team worked diligently and creatively to produce a great site, on budget.",
    authName: "Jeff Crystal",
    authRole: "CEO",
    authImg: "/images/jeffCrystal.webp",
  },
  {
    description:
      "WebReinvent Technologies is a highly skilled team with an eye for details. We got exactly what we wanted and more. The project management and communication works really well through the online project tools and the dedicated project manager made a great job keeping things together. We are looking forward to the next collaboration!",
    authName: "Daniel Bates",
    authRole: "CEO",
    authImg: "/images/danielBates.webp",
  },
  {
    description:
      "Thank you for doing such a great job on our website. Having that personalized approach to helping our business grow with a new and more professional look was invaluable. You diligently worked with us and came up with a brilliant design that represents our company. We are really pleased with the result and it was a pleasure working with you.",
    authName: "Pawan Shah",
    authRole: "CEO",
    authImg: "/images/pawanShah.webp",
  },
  {
    description:
      "I have been working with WebReinvent for over a year now. They are extremely timely and very professional. I recommend their work to my friends and colleagues all the site because of their creativity in generating ideas for enhancing my site. If you have a business or need to develop your online presence, WebReinvent is for you!!",
    authName: "Darrell Bennett",
    authRole: "CEO",
    authImg: "/images/darrellBennett.webp",
  },
  {
    description:
      "Working with the WebReinvent team was a pleasant experience. Two things in particular about their service is exceptional: their speed of response to emails, they were always available to answer my questions and provide feedback as the project went along. Secondly they demonstrated a clear understanding of the scope and nature of the project and delivered accordingly.",
    authName: "Geoffrey Nwachukwu",
    authRole: "CEO",
    authImg: "/images/geoffreyNwachukwu.webp",
  },
]);

const responsiveOptions = ref([
  { breakpoint: "1400px", numVisible: 1, numScroll: 1 }, // For extra-large screens
  { breakpoint: "1200px", numVisible: 1, numScroll: 1 }, // For large screens
  { breakpoint: "992px", numVisible: 1, numScroll: 1 }, // For medium screens
  { breakpoint: "768px", numVisible: 1, numScroll: 1 }, // For smaller tablets
  { breakpoint: "576px", numVisible: 1, numScroll: 1 }, // For mobile screens
]);
</script>
<template>
  <Carousel
    :showNavigators="false"
    :value="categories"
    :num-visible="1"
    :num-scroll="1"
    :responsive-options="responsiveOptions"
    :pt="{
      itemList: { class: '' },
      item: {
        class: 'bg-transparent  *:even:bg-[#FFFFFF] *:odd:bg-[#F5F5F5]',
      },
      indicatorbutton: {
        class:
          '!rounded-full !size-4 !border !border-[#6727BB] !border-solid !bg-transparent',
      },
      indicatorList: {
        class: '!pb-0',
      },
      content: { class: '' },
    }"
    :autoplay-interval="5000"
    circular
    :drag-enabled="true"
    touch-enabled
  >
    <template #item="slotProps">
      <div
        class="mx-1 p-px dark:bg-[linear-gradient(91.95deg,rgba(98,69,116,1)_4.5%,rgba(122,84,157,1)_96.91%)] bg-[linear-gradient(91.95deg,rgba(242,242,242,0.7)_4.5%,rgba(204,204,204,0.7)_96.91%)] rounded-2xl xl:max-h-[274px] h-full"
      >
        <div
          class="c-carousel bg-[image:var(--bg-card-carousel)] overflow-hidden rounded-2xl h-full"
        >
          <Card
            unstyled
            class="bg-[var(--bg-card-carousel)] overflow-hidden relative px-8 py-6 text-black dark:text-white h-full"
            :pt="{
              body: {
                class: 'h-full',
              },
              content: {
                class: 'flex flex-col justify-between h-full',
              },  
            }"
          >
            <template #content>
              <p class="text-base">{{ slotProps.data.description }}</p>
              <div class="flex items-center gap-4 mt-4">
                <div
                  class="p-px bg-[linear-gradient(180deg,_#F5F2FF_0%,_#C4C2E0_100%)] rounded-full"
                >
                  <NuxtImg
                    alt="authImg"
                    :src="slotProps.data.authImg"
                    width="64"
                    height="64"
                    loading="lazy"
                    class="rounded-full p-[2px] bg-[image:var(--border-testimonial-card)]"
                     format="webp"
                  />
                </div>
                <div>
                  <p class="text-base">{{ slotProps.data.authName }}</p>
                  <p class="text-[#996FF4] dark:text-[#996FF4] text-base">
                    {{ slotProps.data.authRole }}
                  </p>
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>
    </template>
  </Carousel>
</template>

<style scoped></style>
